<template>
  <div id="Routes">

    <b-container fluid>
      <b-row class="mb-1 text-left">
        <b-col >
          <h1 class="labelBold">{{ this.$t(`bookingTransport.Routes.title`) }} </h1>
        </b-col>
      </b-row>

      <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12">
        <b-col sm="2" lg="2">
          <label class="labelBold">{{ $t("bookingTransport.Routes.id") }}</label>
          <input type="text" v-model="route.id" />
          <div v-if="$v.route.id.$error" class="error-msg">
            <p v-if="!$v.route.id.required">{{$t("bookingTransport.Routes.id")}}{{$t("bookingTransport.required")}}</p>
          </div>

        </b-col>
        <b-col sm="3" lg="3">
          <label class="labelBold">{{ $t("bookingTransport.Routes.route_name")}}</label>
          <input type="text" v-model="route.route_name"/>
          <div v-if="$v.route.route_name.$error" class="error-msg">
            <p v-if="!$v.route.route_name.required">{{$t("bookingTransport.Routes.route_name")}}{{$t("bookingTransport.required")}}</p>
          </div>
        </b-col>
        <b-col sm="2" lg="2">
          <label class="labelBold">{{ $t("bookingTransport.Routes.platform_id") }}</label>
          <input type="number" v-model="route.platform_id"/>
          <div v-if="$v.route.platform_id.$error" class="error-msg">
            <p v-if="!$v.route.platform_id.required">{{$t("bookingTransport.Routes.platform_id")}}{{$t("bookingTransport.required")}}</p>
          </div>
        </b-col>
        <b-col sm="2" lg="2">
          <button class="btn-confirm" @click="CreateRoute(true)">{{ $t("bookingTransport.Platform.add") }}</button>
        </b-col>
        <b-col sm="3" lg="3">
          <div class="container-input">
            <input type="file" name="file-2" id="file-2" class="inputfile inputfile-2" @change="loadCSV($event)" accept=".csv" data-multiple-caption="{count} archivos seleccionados" multiple />
            <label for="file-2">
              <i style='font-size:24px' class='fas'>&#xf6dd;</i>
              <span class="iborrainputfile" id="filecsv"> {{ $t("bookingTransport.selectFile") }}</span>
            </label>
            <div >
              <i style='font-size:24px; float:left;' class='fas btn-outline-secondary' @click="showInf()">&#xf05a;</i>
            </div>
            <div v-if="file">
              <i style='font-size:24px; float:right;' class='fas btn-outline-secondary' @click="removeFile()">&#xf1f8;</i>
            </div>
          </div>
        </b-col>

      </b-row>
      <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12">
        <b-col sm="9" lg="9">
        </b-col>

        <b-col  sm="3" lg="3" v-if="fileOk">
          <center>
            <button class="btn-confirm" @click="Upload()">{{ $t("bookingTransport.upload") }}</button>
          </center>
        </b-col>

      </b-row>

      <!-- <b-row>

      </b-row> -->
    </b-container>
    <div class="row">
      <div class="col-md-12">
        <!--
       <v-client-table v-if="tableData" :data="tableData" :columns="table_optionsCarga.columns" :options="table_optionsCarga.options">
            <template v-slot:action="props">
               <center><i style='font-size:24px' class='fas btn-outline-secondary' @click="Modify(props.row.name)">&#xf044;</i></center>
               <b-button v-b-popover="'Popover inside a modal!'" title="Popover">Button</b-button>
               </template>
       </v-client-table>-->

        <v-server-table :columns="table_options.columns" :options="table_options.options" ref="routesTable" id="routesTable">
          <template #driver_status="props">{{ translateStatus(props.row.driver_status) }}</template>

          <template v-slot:actions="props">
            <center><i style='font-size:24px' class='fas btn-outline-secondary' @click="Modify(props.row)">&#xf044;</i></center>

            <!-- <b-button v-b-popover="'Popover inside a modal!'" title="Popover">Button</b-button> -->
          </template>

          <!--<div slot="filter__driver_status">
                  <select class="form-control" name="driver_status" id ="driver_status" v-model="selected"  @change="filterStatus(selected)">
                  <option v-for="option in options"
                  v-bind:key="option.id"
                  v-bind:value="option.id">
                  {{option.name }}
                  </option>
                  </select>
        </div> -->
        </v-server-table>
      </div>
    </div>

    <b-modal size="lg" centered ref="my-info"  scrollable :title="$t('bookingTransport.infoCsv')" tabindex="-1" >
      <div v-if="appLang =='es'">
        <p>
          Archivo en formato .csv
          <br/>
          Nombre de columnas: Id_Ruta, Descripción_Ruta,	Id_Anden
          <br/>
        </p>
      </div>
      <div v-if="appLang =='en'">
        File in .csv format
        <br/>
        Column name: Id_Ruta, Descripción_Ruta,	Id_Anden
        <br/>
      </div>

      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right btn-xl"
            @click="DowloadLayout()"
          >
            {{ $t("bookingTransport.download") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="lg" centered ref="my-error" hide-footer scrollable :title="$t('bookingTransport.errorUpload')" tabindex="-1" >
      <div>
             <textarea v-model="error" class="form-control" rows="15">
             </textarea>
      </div>

      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="DowloadLayout()">
            {{ $t("bookingTransport.download") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered ref="my-edit" no-close-on-backdrop  :title="$t('bookingTransport.edit')" tabindex="-1" >
      <template #modal-header>




        <div class="w-100" >
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.Routes.editRoute')}}</p>
          </h3>
        </div>
      </template>
      <b-container class="bv-example-row">

        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">

          <b-col sm="3">
            <label class="black">{{ $t("bookingTransport.Routes.route_name") }}</label>
            <!-- <input class="form-control" type="text" id="routes" v-model="filterRoutes" placeholder="Filter routes.." @keyup="getRoutes" /> -->
            <select class="form-control" v-model="idRoute" id="routes" disabled>
              <option value="0" disabled>{{$t('bookingTransport.select')}}</option>
              <option v-for="data in arrayRutas" :key="data.id" :value="data.id" v-text="data.route_name"></option>
            </select>
            <!-- <Select v-model="idcategoria" filterable :options="arrayRutas"  placeholder="Please select your content"></Select> -->
          </b-col>

          <b-col sm="3">
            <div class="">
              <label class="labelBold mt-2">
                {{ $t("bookingTransport.Routes.platform_id")}}
              </label>
              <input type="number" v-model="idPlatform"/>
            </div>
            <!--<label class="black">{{ $t("bookingTransport.planning.platform") }}</label>
            <input class="form-control" type="text" id="platform" v-model="filterPlatform" placeholder="Filter Platforms.." @keyup="getPlatform" />
            <select class="form-control" v-model="idPlatform" id="platform">
            <option value="0" disabled>Seleccione</option>
            <option v-for="data in arrayPlatform" :key="data.id" :value="data.id" v-text="data.platform_name"></option>
            </select>-->
            <!--<Select v-model="idcategoria" filterable :options="arrayRutas"  placeholder="Please select your content"></Select>-->
          </b-col>

          <b-col sm="2" lg="2">
            <!-- <button class="btn-confirm" @click="CreateRoute(false)">{{ $t("bookingTransport.Platform.add") }}</button>  -->
            <button class="btn-confirm" @click="CreateRoute(false)">{{ $t("bookingTransport.save") }}</button>
          </b-col>
          <!--  <b-col sm="1">
                    <div class="public-checkbox">
                    <input type="checkbox" id="public-checkbox" v-model="massive" />
                   <label for="public-checkbox">{{ $t("bookingTransport.planning.period") }}</label>
                     <label for="public-checkbox">Planeación masiva</label>
                    </div>
            </b-col>
             <b-col sm="2">
                      <div v-if="massive">
                                <button class="btn-confirm btn-outline-secondary" @click="PrePlanning">
                                {{ $t("bookingTransport.planning.prePlanning") }}
                                <i style='font-size:24px' class='fas'>&#xf0c7;</i>
                                </button>
                                </div>
                                <div v-else>
                                       <button class="btn-confirm btn-outline-secondary" @click="SavePlanning">
                                        {{ $t("bookingTransport.planning.createPlanning") }}
                                        <i style='font-size:24px' class='fas'>&#xf0c7;</i>
                                        </button>
                                </div>
                    </b-col>  -->
        </b-row>

        <!-- <div class="col-md-12" v-if="tableData"> -->
        <v-client-table :data="tableData" :columns="table_optionsStops.columns" :options="table_optionsStops.options" ref="PlanningStops" id="PlanningStops">

          <!-- <template #error="props">{{ translateError(props.row.error)}}</template>  -->

          <template #error="props"> <div  style="color:red;" v-if="props.row.error"> {{"Error"}} </div></template>

          <template #schedule="props">{{ props.row.schedule }}</template>
          <template v-slot:edit="props">
            <center>
              <i style='font-size:24px' class='fas btn-outline-dark' @click="ModifyStops(props.row,false)">&#xf044;</i>
            </center>
          </template>
          <!-- <template v-slot:remove="props">
          <center>
          <i style='font-size:24px' class='fas btn-outline-secondary' @click="ModifyStops(props.row,true)">&#xf1f8;</i>
          </center>
          </template> -->
          <button
            class="btn-confirm btn-outline-secondary"
            slot="beforeLimit"
            type="primary"
            @click="showModalCreate">
            {{ $t("bookingTransport.Routes.AddStop") }}

          </button>
          <!-- @click="AddRoutes"> -->
        </v-client-table>

      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <!-- <b-button
         size="lg"
         class="btn btn-dark float-right"
         @click="EditConfirmPrePlanning()"
       >
         Confirmar
       </b-button> -->
          <b-button
            size="lg"
            class="btn btn-light float-right btn-xl"
            @click="closeEditPrePlanning()"
          >
            {{ $t("bookingTransport.cancel") }}

          </b-button>
        </div>
      </template>
    </b-modal>



    <b-modal style="z-index:10" size="xl" centered ref="my-edit-stop" no-close-on-backdrop :title="$t('bookingTransport.edit')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100" v-if="nuevo">
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.Stops.new')}}</p>
          </h3>
        </div>
        <div class="w-100" v-else>
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.Stops.edit')}}</p>
          </h3>
        </div>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="2">
            <label class="labelBold">{{ $t("bookingTransport.Stops.TableStops.headings.id") }}</label>
            <input type="text" v-model="$v.Stops.id.$model" :disabled="nuevo == false"/>
            <div v-if="$v.Stops.id.$error" class="error-msg">
              <p v-if="!$v.Stops.id.required">{{$t("bookingTransport.Stops.TableStops.headings.idrequired")}}</p>
            </div>
          </b-col>
          <b-col sm="8">
            <label class="labelBold">{{ $t("bookingTransport.Stops.TableStops.headings.stop_name") }}</label>
            <input type="text" v-model="$v.Stops.stop_name.$model" />
            <div v-if="$v.Stops.stop_name.$error" class="error-msg">
              <p v-if="!$v.Stops.stop_name.required">{{$t("bookingTransport.Stops.TableStops.headings.stop_namerequired")}}</p>
            </div>
          </b-col>

          <b-col sm="2">
            <div class="enable-checkbox">
              <input type="checkbox" id="enable-checkbox" v-model="enableStop" @click="PrePlaneacionClick()"/>
              <!-- <label for="public-checkbox">{{ $t("bookingTransport.planning.period") }}</label> -->
              <label for="enable-checkbox">{{ $t("bookingTransport.Enable") }}</label>
            </div>
          </b-col>
        </b-row>
        <br/>
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="6">
            <label class="labelBold">{{ $t("bookingTransport.Stops.TableStops.headings.coordenates") }}</label>
            <input type="text" v-model="$v.Stops.coordenatesv.$model"/>
            <div v-if="$v.Stops.coordenatesv.$error" class="error-msg">
              <p v-if="!$v.Stops.coordenatesv.required">{{$t("bookingTransport.Stops.TableStops.headings.coordenatesrequired")}}</p>
              <p v-if="!$v.Stops.coordenatesv.coord">{{$t("bookingTransport.Stops.TableStops.headings.coordenatesinvalid")}}</p>
            </div>
          </b-col>
          <b-col sm="6">
            <label class="black">{{ $t("bookingTransport.planning.route") }}</label>
            <!-- <input class="form-control" type="text" id="routes" v-model="filterRoutes" placeholder="Filter routes.." @keyup="getRoutes" /> -->
            <select class="form-control" v-model="$v.idRoute.$model" id="routes" disabled>
              <option value="0" disabled>Seleccione</option>
              <option v-for="data in arrayRutas" :key="data.id" :value="data.id" v-text="data.route_name"></option>
            </select>
            <div v-if="$v.idRoute.$error" class="error-msg">
              <p v-if="!$v.idRoute.ids">{{$t("bookingTransport.Stops.TableStops.headings.route_idrequired")}}</p>
            </div>
          </b-col>


        </b-row>
        <br/>
        <br/>
        <b-row cols="0" cols-sm="1" cols-md="3" cols-lg="6">
          <b-col sm="2">
            <h4>
              <!-- <p class="labelBold float-left">{{$t('bookingTransport.edit')}}</p> -->
              <center>
                <p class="labelBold float-left">{{$t('bookingTransport.AddHorario')}}</p>
              </center>
            </h4>
          </b-col>
          <b-col sm="2">
            <label class="black">{{ $t("bookingTransport.planning.schedule") }}</label>
            <input class="form-control" type="text" id="schedule" v-model="filterSchedule" placeholder="Filter Schedule.." @keyup="getSchedule" />
            <select class="form-control" v-model="idSchedule" id="schedule" @change="showSetStops">
              <option value="0" disabled>{{$t('bookingTransport.select')}} </option>
              <option v-for="data in arraySchedule" :key="data.id" :value="data.id" v-text="data.shift_name"></option>
            </select>
          </b-col>
          <b-col  sm="2">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.start_time") }}</label>
            <vue-timepicker class="noEditable" v-model="ScheduleValidate.start_time" disabled readonly></vue-timepicker>
          </b-col>
          <b-col  sm="2">
            <label  class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.end_time") }}</label>
            <vue-timepicker class="noEditable" v-model="ScheduleValidate.end_time" disabled readonly></vue-timepicker>
          </b-col>
          <b-col  sm="2">
            <label class="black">{{ $t("bookingTransport.planning.TableStops.headings.schedule") }}</label>
            <vue-timepicker v-model="timeStop" ></vue-timepicker>
          </b-col>
          <b-col sm="2">
            <button  class="btn-confirm" @click="AddSchedule()">{{ $t("bookingTransport.Stops.add") }}</button>
          </b-col>
        </b-row>

        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="6">
            <v-client-table :data="tableDataSchedule" :columns="table_optionsAddSchedule.columns" :options="table_optionsAddSchedule.options" ref="Schedule" id="Schedule">

              <template #id="props">{{ translateStatus(props.row.id) }}</template>

              <template v-slot:edit="props">
                <!--style='font-size:18px; width:30px; height:30px;'-->
                <center>
                  <i style='font-size:.9rem' class='fa btn btn-outline-secondary' @click="ModifySchedule(props.row,true)">&#xf044;</i>
                </center>
                <!--<b-button v-b-popover="'Popover inside a modal!'" title="Popover">Button</b-button> -->
              </template>

              <template v-slot:delete="props">
                <center>
                  <i style='font-size:.9rem' class='fa btn btn btn-outline-danger' @click="DeleteScheduleData(props.row,true)">&#xf1f8;</i>
                </center>
                <!-- b-button v-b-popover="'Popover inside a modal!'" title="Popover">Button</b-button>-->
              </template>
            </v-client-table>
          </b-col>
        </b-row>

      </b-container>


      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditConfirm(nuevo)"
          >
            {{ $t("bookingTransport.save") }}

          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeEditStops()"
          >
            {{ $t("bookingTransport.cancel") }}
          </b-button>

        </div>
      </template>
    </b-modal>


    <b-modal size="lg" centered ref="my-delete" no-close-on-backdrop tabindex="-1" >
      <template #modal-header>
        <h3>
          <p class="labelBold float-left">{{ $t("bookingTransport.DeleteSchedule") }}</p>
        </h3>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="1" >
            <i style="font-size:50px; color:red" class="fa">&#xf071;</i>
          </b-col>
          <b-col sm="11">
            <h4 class="labelBold">{{ $t("bookingTransport.Stops.confirmDelete") }}</h4>
          </b-col>
        </b-row>
        <br/>
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="4">
            <label class="labelBold">{{ $t("bookingTransport.Schedule.tableSchedule.headings.id") }}</label>
            <input type="text" v-model="DeleteIdSchedule" disabled/>
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.shift_name") }}</label>
            <input type="text" v-model="Delteshift_name" disabled/>
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.Hour") }}</label>
            <input type="text" v-model="DeleteSchedule" disabled/>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="DeleteScheduleData('Delete',false)"
          >
            {{ $t("bookingTransport.confirm") }}

          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeDelete()"
          >
            {{ $t("bookingTransport.cancel") }}

          </b-button>
        </div>
      </template>
    </b-modal>


    <b-modal size="lg" centered ref="my-error" hide-footer scrollable :title="$t('bookingTransport.errorUpload')" tabindex="-1" >
      <div>
             <textarea v-model="error" class="form-control" rows="15">
             </textarea>
      </div>

      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="DowloadLayout()">
            {{ $t("bookingTransport.download") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="lg" centered ref="my-editHour" no-close-on-backdrop tabindex="-1" >
      <template #modal-header>
        <h3>
          <p class="labelBold float-left">{{ $t("bookingTransport.EditHour") }}</p>
        </h3>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="1">
            <label class="labelBold">{{ $t("bookingTransport.planning.schedule") }}</label>
            <input type="text" v-model="idSchedule" disabled/>
          </b-col>
          <b-col sm="3">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.shift_name") }}</label>
            <input type="text" v-model="ScheduleValidate.shift_name" disabled/>
          </b-col>
          <b-col sm="2">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.start_time") }}</label>
            <vue-timepicker class="noEditable"  v-model="ScheduleValidate.start_time" disabled></vue-timepicker>
          </b-col>
          <b-col sm="2">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.end_time") }}</label>
            <vue-timepicker class="noEditable"  v-model="ScheduleValidate.end_time" disabled></vue-timepicker>
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.Hour") }}</label>
            <vue-timepicker v-model="timeStop" ></vue-timepicker>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditScheduleHour()"
          >
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeEditHour()"
          >
            {{ $t("bookingTransport.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>



  </div>
</template>

<script>

const ids = (value) => value != 0;
// const coord = (value) => this.isValidCoordinates(value);
// import GoogleMapsApiLoader from 'google-maps-api-loader'
import { required, url, decimal , coordenates} from "vuelidate/lib/validators";

import API_SERVICE from "@/lib/api/Booking.js";
import store from '@/vuex/store';

import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";

const api = new API_SERVICE();


import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();

export default {

  components: {
    store,
    VueTimepicker
  },

  data() {
    return {

      Stops: {
        coordenatesv: null,
        id: null,
        route_id:null,
        schedule: null,
        stop_name: null,
        stop_number: ""},

      ScheduleValidate:{
        shift_name:'',
        start_time:'',
        end_time:''},

      filterRoutes: '',
      filterSchedule:'',
      idSchedule:null,
      arraySchedule:[],
      timeStop:"",
      tableDataSchedule:[],

      enableStop:true,

      EditIdSchedule:null,
      DeleteIdSchedule:null,
      Delteshift_name:null,
      DeleteSchedule:'',



      route:{
        id:"",
        platform_id:"",
        route_name:"",
      },
      // id:"",
      // platform_id:"",
      // route_name:"",

      EditAnden:"",
      filePlatform:null,
      filelocation:null,
      error:null,
      file:false,
      fileOk:false,

      idRoute:0,
      idPlatform:0,

      arrayRutas:[],


      nuevo:false,
      selected:"",
      id:"",

      car_plate:"",
      status:"",
      controlNumber:"",
      columns: [
        "id",
        "name",
        "action",],
      tableData: [
        {
          "id": 12168,
          "name": "Capu"

        },
        {
          "id": 11963,
          "name": "Las Animas"

        },
        {
          "id": 11352,
          "name": "Loreto"

        }
      ]
    };
  },

  validations: {
    route:{
      id:{
        required
      },
      platform_id:{
        required
      },
      route_name:{
        required
      }
    },
    Stops: {
      id:{
        required
      },
      stop_name: {
        required
      },
      coordenatesv:{
        required,
        //  coord
        // coordenates
        // sits_val: function(value) {
        //   if (value <= this.capacity)
        //   return true;
        //   if (value >= this.capacity)
        //   return false;
        // },

        coord: function(coordinates) {
          if (!coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/)) {

            return false;
          }
          const [latitude, longitude]= coordinates.split(",");
          return (latitude>-90 && latitude<90 && longitude>-180 && longitude<180);
        }




      }
    },
    idRoute:{
      ids
    }
  },

  computed:{

    routesTable: function() {
      return this.$refs.routesTable;

    },
    appLang: function ()
    {
      return this.$store.getters["settings/currentLang"];
    },

    options(){
      return[
        {id:"choose",name: this.$t('mobilityOnDemand.choose')} ,
        {id:true,name: this.$t("mobilityOnDemand.driversMobility.active")} ,
        {id:false,name: this.$t("mobilityOnDemand.driversMobility.inactive")},
        {id:null,name: this.$t("mobilityOnDemand.driversMobility.noDriver")}
      ]},


    tableSchedule_columns: function() {
      return [   "id",
        "schedule",
        "edit",
        "delete",];
    },

    table_headingsSchedule: function () {
      if (this.tableSchedule_columns) {
        const headings = {};
        this.tableSchedule_columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.Stops.TableSchedule.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersSchedule: function () {
      return this.tableSchedule_columns.filter((column) => column !== "edit" && column !== "delete");
    },
    table_optionsAddSchedule: function () {
      return {
        columns: this.tableSchedule_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_headingsSchedule,
            //  filterable: this.table_filtersSchedule,
            filterable: false,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 50,
            perPageValues: [10, 25, 50, 100],
            columnsClasses: {
              edit : "select-columnSchedule",
              delete: "select-columnSchedule",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableStops.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableStops.headings.limit")
            },
          },
      };
    },


    table_columns: function() {
      return [
        "id",
        "route_name",
        "actions"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `bookingTransport.Routes.TableRoutes.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "actions");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPageValues: [5,10, 25, 50, 100],
          perPage: 5,
          columnsClasses: {
            actions: "actions-column",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("bookingTransport.Routes.TableRoutes.headings.column_toggler"),
            limit: this.$t("bookingTransport.Routes.TableRoutes.headings.limit")

          },

          requestAdapter: function(data) {
            const queries = {};
            queries.catalogType = "routes"
            queries.pagination= {all:false,
              limit:data.limit,
              page:data.page
            };
            queries.filters = data.query;
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {

              const resp = await api.getLists(data);
              this.$store.commit("global/SET_LOADING", false);
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: `${error}`,
                show: true,
                type: "error"
              });
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.data,
              count: response.total
            };
          }
        }
      };
    },

    table_headingsCarga: function () {
      if (this.columns) {
        const headings = {};
        this.columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.Platform.tablePlatform.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersCarga: function () {
      return this.columns.filter((column) => column !== "action");
    },
    table_optionsCarga: function () {
      return {
        columns: this.columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headingsCarga,
          filterable: this.table_filtersCarga,
          sortable: [],
          resizableColumns: false,// columnas fijas
          perPage: 25,
          perPageValues: [25, 50, 100],
          columnsClasses: {
            select: "select-column",
            id: "id-column",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler"),
            limit: this.$t("users.search.table.limit")
          },
        },
      };
    },

    tableStops_columns: function() {
      return [    "id",
        // "route_id",
        // "stop_number",
        "stop_name",
        "coordenates",
        "schedule",
        //"error",
        "edit",
        // "remove"
      ];
    },

    table_headingsStops: function () {
      if (this.tableStops_columns) {
        const headings = {};
        this.tableStops_columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.planning.TableStops.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersStops: function () {
      return this.tableStops_columns.filter((column) => column !== "edit" && column !== "remove");
    },

    table_optionsStops: function () {

      return {
        columns: this.tableStops_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_headingsStops,
            filterable: this.table_filtersStops,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 10,
            perPageValues: [5, 25, 50, 100],
            columnsClasses: {
              select: "select-column",
              id: "id-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableStops.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableStops.headings.limit")
            },
          },
      };
    },





  },
  beforeMount: async function() {
    this.$store.commit("global/SET_LOADING", true);
    await this.getRoutes();
    await this.getSchedule();
    this.$store.commit("global/SET_LOADING", false);
  },

  methods: {

    closeEditHour(){
      this.timeStop = '00:00';
      this.idSchedule = null;
      this.ScheduleValidate.shift_name = '';
      this.ScheduleValidate.start_time = '00:00';
      this.ScheduleValidate.end_time = '00:00';
      this.$refs['my-editHour'].hide();
    },

    EditScheduleHour: function(){
      try{
        if(this.timeStop >= this.ScheduleValidate.start_time && this.timeStop <= this.ScheduleValidate.end_time)
        {
          const pos = this.tableDataSchedule.map(e => e.id).indexOf(this.EditIdSchedule);
          this.tableDataSchedule.splice(pos,1,{
            id:this.EditIdSchedule,
            schedule:this.timeStop
          });
          this.timeStop = '00:00';
          this.idSchedule = null;
          this.ScheduleValidate.shift_name = '';
          this.ScheduleValidate.start_time = '00:00';
          this.ScheduleValidate.end_time = '00:00';

          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.update")}`,
            show: true,
            type: "success"
          });

          this.$refs['my-editHour'].hide();
        }
        else if(this.ScheduleValidate.end_time <= this.ScheduleValidate.start_time){

          if((this.timeStop >= this.ScheduleValidate.start_time)||(this.timeStop >= '00:00' && this.timeStop <= this.ScheduleValidate.end_time)){

            const pos = this.tableDataSchedule.map(e => e.id).indexOf(this.EditIdSchedule);
            this.tableDataSchedule.splice(pos,1,{
              id:this.EditIdSchedule,
              schedule:this.timeStop
            });
            this.timeStop = '00:00';
            this.idSchedule = null;
            this.ScheduleValidate.shift_name = '';
            this.ScheduleValidate.start_time = '00:00';
            this.ScheduleValidate.end_time = '00:00';

            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.update")}`,
              show: true,
              type: "success"
            });

            this.$refs['my-editHour'].hide();
            return;


          }
          else{
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.Nocorresponds")}`,
              show: true,
              type: "error"
            });
          }
        }
        else{
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.Nocorresponds")}`,
            show: true,
            type: "error"
          });

        }
      }
      catch(error){
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });

      }

    },


    ModifySchedule: function(data,action){
      try {
        this.$store.commit("global/SET_LOADING", true);
        this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == data.id);
        this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
        this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
        this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;
        this.idSchedule= data.id;
        this.EditIdSchedule = data.id;
        this.timeStop= data.schedule;
        this.$store.commit("global/SET_LOADING", false);
        this.$refs['my-editHour'].show();

      }
      catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }

    },

    isValidCoordinates(coordinates) {
      if (!coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/)) {
        return false;
      }
      const [latitude, longitude]=coordinates.split(",");
      return (latitude>-90 && latitude<90 && longitude>-180 && longitude<180);
    },

    showModalCreate() {

      try{
        this.$store.commit("global/SET_LOADING", true);
        this.nuevo = true;
        this.Stops.id = '';
        this.Stops.stop_name = '';
        this.Stops.coordenatesv = '';
        this.idRoute = this.idRoute;
        this.idSchedule = this.idSchedule;
        this.timeStop = '';
        this.ScheduleValidate.shift_name = '';
        this.ScheduleValidate.start_time = '';
        this.ScheduleValidate.end_time = '';
        this.tableDataSchedule = [];
        this.$refs['my-edit-stop'].show();
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });

      }
    },

    DeleteScheduleData: function(data,action){

      try{
        this.$store.commit("global/SET_LOADING", true);
        if(action)
        {
          var ValidateSchedule = [];
          ValidateSchedule = this.arraySchedule.filter((e)=> e.id == data.id);
          this.DeleteIdSchedule = data.id;
          this.Delteshift_name = ValidateSchedule[0].shift_name;
          this.DeleteSchedule = data.schedule;
          this.$refs['my-delete'].show();
          this.$store.commit("global/SET_LOADING", false);
          return;
        }

        if(data == "Delete")
        {
          const pos = this.tableDataSchedule.map(e => e.id).indexOf(this.DeleteIdSchedule);
          this.tableDataSchedule.splice(pos,1);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.planning.deleteSuccess")}`,
            show: true,
            type: "success"
          });
          this.$refs['my-delete'].hide();


          this.timeStop = '00:00';
          this.idSchedule = null;
          this.ScheduleValidate.shift_name = '';
          this.ScheduleValidate.start_time = '00:00';
          this.ScheduleValidate.end_time = '00:00';
          this.$store.commit("global/SET_LOADING", false);
          return;
        }
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });

      }
    },

    closeDelete(){
      this.timeStop = '00:00';
      this.idSchedule = 0;
      this.ScheduleValidate.shift_name = '';
      this.ScheduleValidate.start_time = '00:00';
      this.ScheduleValidate.end_time = '00:00';
      this.$refs['my-delete'].hide();
    },

    AddSchedule(){
      var ValidateSchedule = [];
      ValidateSchedule = this.tableDataSchedule.filter((e)=> e.id == this.idSchedule);
      if(ValidateSchedule.length>0){
        this.$store.commit("global/SET_ALERT", {
          // msg: "El horario ya existe para el Turno seleccionado",
          msg:`${this.$t("bookingTransport.scheduleExist")}`,
          show: true,
          type: "error"
        });
        return;
      }
      else if(this.idSchedule == null || this.idSchedule == 0){
        this.$store.commit("global/SET_ALERT", {
          // msg: `${this.$t("bookingTransport.planning.falseSchedule")}`,
          msg:`${this.$t("bookingTransport.selectSchedule")}`,
          // msg: "Seleccione Horario",
          show: true,
          type: "error"
        });
        return;

      }
      else{

        if(this.timeStop >= this.ScheduleValidate.start_time && this.timeStop <= this.ScheduleValidate.end_time  )
        {
          var json = {id:this.idSchedule,
            schedule: this.timeStop};
          this.tableDataSchedule.push(json);
          this.$store.commit("global/SET_ALERT", {
            msg:`${this.$t("bookingTransport.AddSchedule")}`,
            show: true,
            type: "success"
          });
          this.timeStop = '00:00';
          this.idSchedule = null;
          this.ScheduleValidate.shift_name = '';
          this.ScheduleValidate.start_time = '00:00';
          this.ScheduleValidate.end_time = '00:00';
          return;
        }
        else if(this.ScheduleValidate.end_time <= this.ScheduleValidate.start_time)
        {
          if((this.timeStop >= this.ScheduleValidate.start_time)||(this.timeStop >= '00:00' && this.timeStop <= this.ScheduleValidate.end_time)){
            var json = {id:this.idSchedule,
              schedule: this.timeStop};
            this.tableDataSchedule.push(json);
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.AddSchedule")}`,
              show: true,
              type: "success"
            });
            this.timeStop = '00:00';
            this.idSchedule = null;
            this.ScheduleValidate.shift_name = '';
            this.ScheduleValidate.start_time = '00:00';
            this.ScheduleValidate.end_time = '00:00';
            return;


          } else{
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.planning.falseSchedule")}`,
              show: true,
              type: "error"
            });
            return;


          }

        }

        else{
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.planning.falseSchedule")}`,
            show: true,
            type: "error"
          });
        }
        return;
      }
    },

    translateStatus (id) {
      var TranslateSchedule = [];
      TranslateSchedule = this.arraySchedule.filter((e)=> e.id == id);
      return TranslateSchedule[0].shift_name;
    },

    showSetStops: async function (index) {

      try {
        this.$store.commit("global/SET_LOADING", true);
        this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
        this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
        this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
        this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;
        this.timeStop = this.ScheduleValidate.start_time;
        this.$store.commit("global/SET_LOADING", false);
      }
      catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    getSchedule: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const queries = {};
        queries.action = "list"
        queries.pagination= {all:false,
          limit:300,
          page:1};
        queries.filters = {shift_name:this.filterSchedule};
        const resp = await api.getSchedule(queries);
        this.arraySchedule = resp.data;
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error.response.data.error,
          show: true,
          type: "error"
        });

      }
    },


    ModifyStops: function(data){

      try{

        this.$store.commit("global/SET_LOADING", true);
        this.enableStop = data.enabled;
        this.nuevo = false;
        this.tableDataSchedule = [];
        this.Stops.id = data.id;
        this.Stops.stop_name = data.stop_name;
        this.Stops.coordenatesv = data.coordenates;
        this.Stops.schedule = data.schedule;
        this.idRoute = data.route_id;
        var schedule = data.schedule;
        for (var prop in schedule) {
          if (schedule.hasOwnProperty(prop)) {
            var json = {
              id:prop,
              schedule:schedule[prop]};
            this.tableDataSchedule.push(json);
          }
        }
        this.$refs['my-edit-stop'].show();
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error.response.data.error,
          show: true,
          type: "error"
        });
      }

    },

    AddRoutes: async function () {

      if(this.idRoute == 0)  {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: `${this.$t("bookingTransport.selectRoute")}`,
          show: true,
          type: "error" });
        return;
      }
      this.$refs['add-Stops'].show();
      try{

        var arrayRutasPre = [];

        this.arrayAddRutas = [];
        this.$store.commit("global/SET_LOADING", true);

        const queries = {};
        queries.catalogType = "stops"
        queries.pagination= {
          all:true,
          limit:300,
          page:1};

        queries.filters = {};
        const resp = await api.getLists(queries);

        resp.data.forEach((data, index) => {
          var queries = {};
          queries.id = data.id
          queries.route_id = data.route_id
          queries.stop_number = data.stop_number
          queries.stop_name = data.stop_name
          queries.coordenates = data.coordenates

          if (data.schedule == null)
          {
            queries.schedule = "Ninguno"
          }
          else if (data.schedule != null)
          {
            queries.schedule = data.schedule[this.idSchedule]
            if(queries.schedule == undefined){
              queries.schedule = "Ninguno"
            }else{
              queries.schedule = data.schedule[this.idSchedule]
            }
          }

          if(queries.schedule.length>=4 && queries.schedule.length<5){
            queries.schedule = "0"+ queries.schedule;
          }

          arrayRutasPre.push(queries);
        });

        this.tableData.forEach((data)=> {

          arrayRutasPre = arrayRutasPre.filter((e)=> e.id !== data.id) });


        this.arrayAddRutas =  arrayRutasPre.sort(function (a, b) {
          var x = a['schedule'],
            y = b['schedule'];

          return ((x < y) ? -1 : ((x > y) ? 1 : 0)); });

        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }


    },

    closeEditPrePlanning(){

      this.route.id = "";
      this.route.route_name = "";
      this.route.platform_id = "";

      this.$refs['my-edit'].hide();
    },

    getRoutes: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const queries = {};
        queries.catalogType = "routes"
        queries.pagination= {all:false,
          limit:300,
          page:1};
        queries.filters = {route_name:this.filterRoutes};
        const resp = await api.getLists(queries);
        this.arrayRutas = resp.data;
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    updateTable: function() {
      this.routesTable.refresh();
    },

    Upload: async function(){
      await this.uploadFile();
    },

    uploadFile: async function() {
      try {

        if(this.filelocation){
          this.$store.commit("global/SET_LOADING", true);

          //  console.log(fileResp);
          //  console.log(Bucket);
          //  console.log(Key);
          //  this.alert.status = 'loading';

          var json = {upload_type: "routes",
            url: this.filelocation}

          const resp = await api.uploadFile(json);

          if(resp.message == "Datos insertados correctamente."){
            this.filelocation = null;
            this.filePlatform = null;
            this.file = false;
            this.fileOk = false;
            document.getElementById("file-2").value = "";
            document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");

            this.$store.commit("global/SET_ALERT", {
              msg: this.$t("bookingTransport.success"),
              show: true,
              type: "success"
            });
          }
          else{
            console.log(resp);

            this.$refs['my-error'].show();
            const backendError = resp.errors.toString().replace(/,/g, '\n');
            this.error = backendError;


            //    this.$store.commit("global/SET_ALERT", {
            //    msg: resp,
            //    show: true,
            //    type: "error"
            //  });


          }
          this.updateTable();
          this.$store.commit("global/SET_LOADING", false);
        }
        // else
        // {
        //         this.$store.commit("global/SET_ALERT", {
        //          msg: this.$t("bookingTransport.noFile"),
        //          show: true,
        //          type: "error"
        //        });
        // }
        // await api.uploadUsers(Bucket, Key, userType);
        // this.backendError = '';
        // this.alert.status = 'success';
        // this.loadingFile = false;
        // this.file = null;
        // this.fileUrl = null;
        // this.$v.$reset();
        // this.$emit('updateTable');
      } catch (error) {

        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
        throw error;
      }
    },


    Modify: async function(name){

      this.$store.commit("global/SET_LOADING", true);



      const queries = {};
      queries.action = "preset"
      queries.query = {route_id:name.id};
      // await promise;
      const resp = await api.Planning(queries);
      // console.log(resp.data);
      var ValidateRuta = this.arrayRutas.filter((e)=> e.id == name.id);
      // console.log(ValidateRuta);
      this.idRoute = ValidateRuta[0].id;
      this.idPlatform = ValidateRuta[0].platform_id;
      this.route.route_name = ValidateRuta[0].route_name;


      this.tableData = resp.data;
      this.$store.commit("global/SET_LOADING", false);

      // route.id
      // route.route_name
      // route.platform_id




      this.$refs['my-edit'].show();

    },


    loadCSV: async function(e){

      try{

        this.$store.commit("global/SET_LOADING", true);

        this.filePlatform = e.target.files[0];
        document.getElementById('filecsv').textContent = e.target.files[0].name;
        const timestamp = Date.now();
        let Type = "Routes";
        const file = `Booking/${Type}/${timestamp}_${Type}.csv`;
        const fileResp = await s3.uploadFile(file, this.filePlatform);
        const {Location} = fileResp;
        this.filelocation = Location;
        this.file = true;

        var json = {upload_type: "routes",
          url: Location}

        const resp = await api.validate(json)

        this.$store.commit("global/SET_LOADING", false);

        if(resp.message == "Datos fueron validados correctamente."){

          this.fileOk = true;
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.Routes.ready"),
            show: true,
            type: "success"
          });

        }
        else{
          this.$refs['my-error'].show();
          const backendError = resp.errors.toString().replace(/,/g, '\n');
          // var backendError1 = backendError.toString().replace(/,/g, '\n');
          // alert(backendError.toString());
          //const backendError = error.response.data.err.replace('.', ' ').replace(/required.,/g, 'required.</br>').replace("\n", "<br/>");
          //this.error = resp.errors;
          // this.error = backendError.toString();
          this.error = backendError;
        }
      }
      catch(error)
      {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error.response.data.message,
          show: true,
          type: "error"
        });
      }
    },

    showInf: function(){
      this.$refs['my-info'].show();
    },

    removeFile: function () {

      try{
        this.filelocation = null;
        this.filePlatform = null;
        this.file = false;
        this.fileOk = false;
        document.getElementById("file-2").value = "";
        document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");

        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.filedelete"),
          show: true,
          type: "success"
        });
      }
      catch(error){

        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });

      }
    },
    CreateRoute: async function(value) {

      this.newStop = value;

      if(this.newStop == false){
        this.route.id =this.idRoute
        this.route.platform_id =this.idPlatform
      }


      // console.log("Valida1");
      // console.log(this.newStop);
      //  console.log(this.idRoute);
      //  console.log(this.route.route_name);
      //  console.log(this.idPlatform);

      //  console.log(this.route.id,);
      //  console.log(this.route.route_name);
      //  console.log(this.route.platform_id);

      this.$v.route.$touch();
      if (this.$v.route.$error)return;

      //  console.log("Valida1.1");

      try {
        this.$store.commit("global/SET_LOADING", true);

        var json = null;

        if(this.newStop == true){
          json = {
            id: this.route.id,
            route_name: this.route.route_name,
            platform_id :  this.route.platform_id
          }
        }
        else if(this.newStop == false){
          json = {
            id: this.idRoute,
            route_name: this.route.route_name,
            platform_id :  this.idPlatform
          }

        }





        var resp = null;
        // console.log(json);
        // console.log("Valida2");

        if(this.newStop == true){
          resp = await api.StopsNew({catalogType: "routes",values:json});
        }
        else if(this.newStop == false){

          resp = await api.StopsEdit({catalogType: "routes",values:json});

        }

        if(resp.message == "Los datos se actualizaron correctamente."){

          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.Routes.updateRoute"),
            show: true,
            type: "success"
          });

          await this.getRoutes();
          await this.getSchedule();
          this.routesTable.refresh();
          this.$refs['my-edit'].hide();
          this.$v.$reset();


          // const queries = {};
          //                 queries.action = "preset"
          //                 queries.query = {route_id:this.idRoute};
          //       const resp = await api.Planning(queries);
          //       var ValidateRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
          //       this.idRoute = ValidateRuta[0].id;
          //       this.idPlatform = ValidateRuta[0].platform_id;
          //       this.tableData = resp.data;
          //       this.$store.commit("global/SET_LOADING", false);

        }
        else if(resp.message == "Datos creados correctamente."){
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.Routes.createRoute"),
            show: true,
            type: "success"
          });

          await this.getRoutes();
          await this.getSchedule();
          this.routesTable.refresh();

          this.route.id = "";
          this.route.route_name  = "";
          this.route.platform_id = "";
          this.$v.$reset();




          //  const queries = {};
          //                 queries.action = "preset"
          //                 queries.query = {route_id:this.idRoute};
          //       const resp = await api.Planning(queries);
          //       var ValidateRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
          //       this.idRoute = ValidateRuta[0].id;
          //       this.idPlatform = ValidateRuta[0].platform_id;
          //       this.tableData = resp.data;
          //       this.$store.commit("global/SET_LOADING", false);

        }
        else if(resp.message == "Datos creados correctamente."){
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.Stops.create"),
            show: true,
            type: "success"
          });

          // id = "";
          // route_name= "";
          // platform_id = "";
          await this.getRoutes();
          await this.getSchedule();
          this.routesTable.refresh();
          this.$v.$reset();




        }
        else{
          this.$refs['my-error'].show();
          const backendError = resp.errors.toString().replace(/,/g, '\n');
          this.error = backendError;
        }
        //this.$refs['my-edit-stop'].hide();
        console.log("Valida reload");
        this.$store.commit("global/SET_LOADING", false);
        //this.$v.route.$reset();
        //window.location.reload();
        this.$v.$reset();
        //this.$nextTick(() => { this.$v.$reset(); });

      }

      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error.response.data.error,
          show: true,
          type: "error"
        });

      }


      this.$refs['my-modal'].show();
    },
    closeEdit(){
      this.$refs['my-edit'].hide();
    },
    closeEditStops(){
      this.$refs['my-edit-stop'].hide();
    },
    // EditConfirm(){
    //           this.$store.commit("global/SET_ALERT", {
    //             msg: "Guardado Correctamente",
    //             show: true,
    //             type: "success"
    //           });
    //     this.$refs['my-edit'].hide();
    // },

    EditConfirm: async function(action){


      // this.route.id = "-";
      // this.route.route_name = "-";
      // this.route.platform_id= "-";


      this.$v.Stops.$touch();
      if (this.$v.Stops.$error)return;
      try{
        this.$store.commit("global/SET_LOADING", true);
        var arraySchedule = this.tableDataSchedule;
        var JsonSchedule = {}

        arraySchedule.forEach((data, index) => {
          var idx = data.id;
          var ScheduleX = data.schedule;
          JsonSchedule[idx] = ScheduleX;
        });
        var json = {
          id: this.Stops.id,
          route_id: this.idRoute,
          stop_name : this.Stops.stop_name,
          old_route_id:this.idRoute,
          coordenates: this.Stops.coordenatesv,
          schedule: JsonSchedule,
          enabled:this.enableStop
        }

        var resp = null;
        if(this.nuevo == true){
          console.log("New");
          resp = await api.StopsNew({catalogType: "stops",values:json});
          //resp = await api.StopsEdit({catalogType: "stops",values:json});
        }
        else{
          console.log("edit");
          resp = await api.StopsEdit({catalogType: "stops",values:json});
          //resp = await api.StopsNew({catalogType: "stops",values:json});
        }
        if(resp.message == "Los datos se actualizaron correctamente."){
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.Stops.updated"),
            show: true,
            type: "success"
          });


          const queries = {};
          queries.action = "preset"
          queries.query = {route_id:this.idRoute};
          const resp = await api.Planning(queries);
          var ValidateRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
          this.idRoute = ValidateRuta[0].id;
          this.idPlatform = ValidateRuta[0].platform_id;
          this.tableData = resp.data;
          this.$store.commit("global/SET_LOADING", false);

        }
        else if(resp.message == "Datos creados correctamente."){
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.Stops.create"),
            show: true,
            type: "success"
          });

          const queries = {};
          queries.action = "preset"
          queries.query = {route_id:this.idRoute};
          const resp = await api.Planning(queries);
          var ValidateRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
          this.idRoute = ValidateRuta[0].id;
          this.idPlatform = ValidateRuta[0].platform_id;
          this.tableData = resp.data;
          this.$store.commit("global/SET_LOADING", false);

        }
        else{
          this.$refs['my-error'].show();
          const backendError = resp.errors.toString().replace(/,/g, '\n');
          this.error = backendError;
        }
        this.$refs['my-edit-stop'].hide();
        this.$store.commit("global/SET_LOADING", false);
        this.$v.$reset();

      }

      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error.response.data.error,
          show: true,
          type: "error"
        });

      }

    },




    DowloadLayout(){

      try{
        let anchor = document.createElement("a");
        anchor.href = "https://817467424320-amap-dbs-qa-app-files.s3.ca-central-1.amazonaws.com/Booking/Routes/Rutas_Layout.csv";

        anchor.target = "_blank";
        anchor.click();

        this.$refs['my-info'].hide();
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.dowloaded"),
          show: true,
          type: "success"});

      }
      catch(error){
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    }
  }


};
</script>

<style lang="scss">

#Routes {
  background-color: $white;
  padding: 2rem 4rem;


}

.error-msg {
  color: $warn_red;
  font-size: 14px;
}



#PlanningStops .table-responsive {
  height:400px;
  width: auto;
  overflow:scroll;
}
// #Schedule  .select-column {
//   // position: sticky;
//   left: 0;
//   text-align: center;
//   &:after {
//     content: "";
//     width: 100%;
//     height: 100%;
//     position: absolute;
//     background-color: #f2f2f2;
//     top: 0;
//     left: 0;
//     border-collapse: collapse;
//   }
// }

#routesTable .select-columnSchedule{
  // position: sticky;
  left: 0;
  text-align: center;
  width: 15%;

}
//  width: 100%;
//  height: 100%;
#routesTable .table-responsive {
  height:100%;
  overflow:scroll;
}

#Schedule .select-columnSchedule{
  // position: sticky;
  left: 0;
  text-align: center;
  width: 15%;

}
//  width: 100%;
//  height: 100%;
#Schedule .table-responsive {
  height:200px;
  overflow:scroll;
}






</style>

<style lang="scss" scoped>

.noEditable {
  background-color: #e4e7ea;
  font-stretch: normal;
  font-style: normal;
  font-variant: normal;
  font-weight: bold;
  letter-spacing: normal;
  line-height: normal;
  text-decoration: none;
  text-transform: none;
}


.btn-confirm {
  padding:0.5rem 0.5rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
  font-size: 18px;
  width: 162px;
}


.container-input {
  text-align: center;
  background: #fff; //#b6b0b0;
  border-top: 0px solid #fff; //#000000;
  padding: 0px 0;
  border-radius: 6px;
  width: 90%;
  height: 90%;
  margin: 0 auto;
  margin-bottom: 1em;
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;

}

.inputfile + label {
  max-width: 100%;
  font-size: 1rem;
  font-weight: 200;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.625rem 1.25rem;
}

.inputfile + label i {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.45em;
}

.iborrainputfile {
  font-size:10px;
  margin-left: 1rem;
  padding:1rem 1rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
}

.inputfile-2 + label {
  color: #fff;
  background-color: #000000;
}

.inputfile-2:focus + label,
.inputfile-2.has-focus + label,
.inputfile-2 + label:hover {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #000000;
}

</style>

